export default __webpack_public_path__ + "7f19e4320c42054ed3566954bb4cd3b9.svg";